interface FormProgressProps {
  currentStep: number;
  totalSteps: number;
}

const stepLabels = [
  'Business Info',
  'Design',
  'Content',
  'Contact',
  'Review',
];

export function FormProgress({ currentStep, totalSteps }: FormProgressProps) {
  return (
    <div className="mb-8">
      <div className="flex items-center justify-between mb-2">
        {Array.from({ length: totalSteps }, (_, i) => i + 1).map((step) => (
          <div key={step} className="flex items-center">
            <div
              className={`
                w-10 h-10 rounded-full flex items-center justify-center font-semibold text-sm transition-all duration-300
                ${step < currentStep
                  ? 'bg-primary-500 text-white'
                  : step === currentStep
                    ? 'bg-primary-500 text-white ring-4 ring-primary-100'
                    : 'bg-gray-200 text-gray-500'
                }
              `}
            >
              {step < currentStep ? (
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              ) : (
                step
              )}
            </div>
            {step < totalSteps && (
              <div
                className={`
                  w-full h-1 mx-2 transition-all duration-300
                  ${step < currentStep ? 'bg-primary-500' : 'bg-gray-200'}
                `}
                style={{ minWidth: '40px' }}
              />
            )}
          </div>
        ))}
      </div>
      <div className="flex justify-between">
        {stepLabels.map((label, i) => (
          <span
            key={label}
            className={`text-xs font-medium transition-colors ${
              i + 1 === currentStep ? 'text-primary-600' : 'text-gray-400'
            }`}
            style={{ width: `${100 / totalSteps}%`, textAlign: 'center' }}
          >
            {label}
          </span>
        ))}
      </div>
    </div>
  );
}
